import Swal from 'sweetalert2'

export default {
  mounted() {
    if (window.matchMedia('(max-width: 767px)').matches) {
      this.$store.state.data_sidebartype = 'mini-sidebar'
      $('#main-wrapper').removeClass('show-sidebar')
    }
  },
  methods: {
    editProfile() {
      this.ModalBoots('ProfileModal').show()
    },
    slideToggle() {
      if (window.matchMedia('(max-width: 767px)').matches) {
        this.$store.state.data_sidebartype = 'mini-sidebar'
        $('#main-wrapper').toggleClass('mini-sidebar show-sidebar')
      } else {
        if (this.$store.state.data_sidebartype === 'full') {
          this.$store.state.data_sidebartype = 'mini-sidebar'
        } else {
          this.$store.state.data_sidebartype = 'full'
        }
        $('#main-wrapper').toggleClass('mini-sidebar')
      }
    },
    imageUrlAlt(event) {
      event.target.src = '../../static/assets/images/users/3.jpg'
    },
    logout() {
      Swal.fire({
        title: 'Logout ?',
        text: 'There is a problem with your key, would you like to log out ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#F43131',
        confirmButtonText: 'Logout',
        cancelButtonText: 'Cancel',
        reverseButtons: true,
        customClass: 'Custom_Cancel'
      }).then(result => {
        if (result.isConfirmed) {
          this.logOut()
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/header.js